/* eslint-disable */
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import isEmpty from "lodash.isempty"
import { useParams } from "react-router-dom"

import "components/stylus/BillStatusTimeline.styl"

import { htmlParagraphToLineBreaks, htmlTablesToText, parseHtmlToReact } from "imports/desktopHelperFunctions"
import BillSummary from "profiles-new/components/BillSummary"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import { buildChevronTimelineSteps } from "app/static/frontend/download-center/containers/status/helpers"

export const BillStatusTimeline = ({ data, id, title }) => {
    const {
        aiSummary,
        aiSummaryDate,
        aiSummarySingleSentence,
        statusTimelineData = [],
        sessionStart = "",
        sessionEnd = "",
        summary = "",
        statusDate = "",
        label = "",
        title: billTitle = "",
        currentStatus = "",
        mostRecentBillText,
        enacted_date,
        effective_date,
        effective_date_source,
        is_vetoed,
        veto_date,
        veto_type,
        current_general_status,
        bill_type,
        region,
        major_actions,
        status_actions,
        display_status,
    } = data.length ? data[0] : {}

    const { profileId } = useParams()

    // Determine if we should use the new chevron timeline
    const shouldUseNewTimeline = isFeatureEnabled("ff_bill_status_improvements")

    const getSteps = () => {
        return statusTimelineData.map((status) => (
            <i
                className={classNames("timeline-item", { "timeline-item-completed": status.isCompleted })}
                data-title={status.label}
                key={status.value}
            >
                <div className={classNames("timeline-item-pdf-text", { completed: status.isCompleted })}>
                    {status.label}
                </div>
            </i>
        ))
    }

    // this will not work in IE
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
    // Only map Effective->Enacted for legacy timeline (when FF is disabled)
    // The new chevron timeline (when FF is enabled) handles Effective status natively
    // For users without ff_bill_status_improvements, treat status 7 (Effective) as status 6 (Enacted)
    // since Effective is filtered out from the timeline
    const effectiveStatusValue = DjangIO.app.bill.status.GeneralBillStatus.effective?.value
    const enactedStatusValue = DjangIO.app.bill.status.GeneralBillStatus.enacted?.value
    const statusIdForTimeline = !shouldUseNewTimeline && id === effectiveStatusValue ? enactedStatusValue : id

    const widthVal = statusTimelineData.findIndex((i) => i.value === statusIdForTimeline)

    let numCompleted
    const statusBarLabels = statusTimelineData.map((item, idx) => {
        if (item.value === statusIdForTimeline) {
            numCompleted = idx + 1
        }
        return item.label
    })

    const parsedSummary = summary ? parseHtmlToReact(htmlParagraphToLineBreaks(htmlTablesToText(summary))) : null

    // Build chevron timeline steps if using new timeline
    const chevronSteps = shouldUseNewTimeline
        ? buildChevronTimelineSteps({
              current_general_status,
              bill_type,
              is_vetoed,
              veto_type,
              enacted_date,
              effective_date,
              effective_date_source,
              veto_date,
              major_actions,
              status_actions,
              region,
          })
        : []

    // Use display_status when feature flag is enabled and it's available, otherwise fall back to currentStatus
    // When using display_status, don't pass statusDate because the date is already embedded in the text
    const statusTextToDisplay = shouldUseNewTimeline && display_status ? display_status : currentStatus
    const statusDateToDisplay = shouldUseNewTimeline && display_status ? null : statusDate

    return (
        <React.Fragment>
            <BillSummary
                aiSummaryText={aiSummary}
                aiSummaryDate={aiSummaryDate}
                aiSummarySingleSentence={aiSummarySingleSentence}
                summaryLabel={label && (summary || billTitle) && `${label}:`}
                summaryText={
                    billTitle ? (
                        <React.Fragment>
                            {billTitle}
                            <br />
                            <br />
                            {parsedSummary}
                        </React.Fragment>
                    ) : (
                        parsedSummary
                    )
                }
                statusBarLabels={shouldUseNewTimeline ? [] : statusBarLabels}
                statusBarNumberCompleted={shouldUseNewTimeline ? 0 : numCompleted}
                statusText={statusTextToDisplay}
                statusDate={statusDateToDisplay}
                sessionStartDate={sessionStart}
                sessionEndDate={sessionEnd}
                billId={profileId}
                mostRecentBillText={mostRecentBillText}
                dataType="bill"
                chevronSteps={shouldUseNewTimeline ? chevronSteps : null}
            />
        </React.Fragment>
    )
}

BillStatusTimeline.propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
}

export default BillStatusTimeline
/* eslint-enable */
